(function () {
  function init(section) {
    const scroller = section.querySelector('[data-uh-icons]');
    const progress = section.querySelector('[data-uh-progress]');
    const thumb = section.querySelector('[data-uh-thumb]');

    if (!scroller || !progress || !thumb) return;

    const mobileMq = window.matchMedia('(max-width: 749px)');
    let showProgressForThisLayout = false;

    const getLastItemHiddenRatioAtStart = () => {
      const items = scroller.querySelectorAll('.uh-icon');
      if (!items.length) return 0;

      const lastItem = items[items.length - 1];

      const viewportLeft = scroller.getBoundingClientRect().left;
      const viewportRight = viewportLeft + scroller.clientWidth;

      const itemRect = lastItem.getBoundingClientRect();
      const itemLeft = itemRect.left;
      const itemRight = itemRect.right;

      const visibleLeft = Math.max(itemLeft, viewportLeft);
      const visibleRight = Math.min(itemRight, viewportRight);
      const visibleWidth = Math.max(0, visibleRight - visibleLeft);

      const hiddenWidth = Math.max(0, itemRect.width - visibleWidth);
      return itemRect.width > 0 ? hiddenWidth / itemRect.width : 0;
    };

    const measureLayout = () => {
      if (!mobileMq.matches) {
        showProgressForThisLayout = false;
        return;
      }

const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
const hasRealOverflow = maxScroll > 8;

if (!hasRealOverflow) {
  showProgressForThisLayout = false;
  return;
}

      // IMPORTANT:
      // progress visibility is decided from the START position only
      const prevScrollLeft = scroller.scrollLeft;
      scroller.scrollLeft = 0;

      const lastItemHiddenRatio = getLastItemHiddenRatioAtStart();
      showProgressForThisLayout = lastItemHiddenRatio >= 0.1;

      scroller.scrollLeft = prevScrollLeft;
    };

    const update = () => {
      const isMobile = mobileMq.matches;

      if (!isMobile) {
        scroller.classList.add('is-centered');
        progress.style.display = 'none';
        thumb.style.width = '';
        thumb.style.transform = 'translateX(0px)';
        return;
      }

const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);

/*
  Slider should be enabled ONLY when the progress bar is shown.
  So bar hidden = no sliding.
*/
const enableSlider = showProgressForThisLayout && maxScroll > 8;

if (enableSlider) {
  scroller.classList.remove('is-centered');
  scroller.classList.remove('is-static');
  scroller.classList.add('is-scrollable');
} else {
  scroller.classList.add('is-centered');
  scroller.classList.add('is-static');
  scroller.classList.remove('is-scrollable');
  scroller.scrollLeft = 0;
}

      // BAR VISIBILITY RULE:
      // decided once per layout measurement, not by current scroll position
progress.style.display = enableSlider ? 'block' : 'none';

if (!enableSlider) {
  thumb.style.width = '100%';
  thumb.style.transform = 'translateX(0px)';
  return;
}

      const trackWidth = progress.clientWidth;
      if (!trackWidth) return;

      const ratio = scroller.clientWidth / scroller.scrollWidth;

      let thumbWidth = Math.round(trackWidth * ratio);

      const minW = Math.max(36, Math.round(trackWidth * 0.22));
      const maxW = trackWidth;

      thumbWidth = Math.max(minW, Math.min(maxW, thumbWidth));

      const travel = Math.max(0, trackWidth - thumbWidth);
      const left = maxScroll > 0 ? (scroller.scrollLeft / maxScroll) * travel : 0;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = `translateX(${left}px)`;
    };

    const refresh = () => {
      window.requestAnimationFrame(() => {
        measureLayout();
        update();
      });
    };

    refresh();

    scroller.addEventListener('scroll', () => {
      window.requestAnimationFrame(update);
    }, { passive: true });

    window.addEventListener('resize', refresh);
    window.addEventListener('orientationchange', refresh);
    mobileMq.addEventListener?.('change', refresh);

    const imgs = scroller.querySelectorAll('img');
    imgs.forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', refresh, { once: true });
      }
    });
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target;
    if (section && section.classList.contains('universal-hero')) init(section);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.universal-hero').forEach(init);
  });
})();